import React from 'react'
import { Form } from 'react-bootstrap'

export default function MultiFiles(props) {

    const { label_name, disabled, name, onChange, onBlur, error,required } = props

    return (
        <>
            <Form.Group className="mb-3" controlId="file">
                <Form.Label className='form_label'>{label_name}{required == true ? <span className='required_filed'>*</span>:""}</Form.Label>
                <Form.Control
                    type="file"
                    disabled={disabled}
                    className='form_input'
                    multiple="multiple"
                    name={name}
                    onChange={onChange}
                    onBlur={onBlur}
                   
                />
                {error}
            </Form.Group>
        </>
    )
}
